import {
  Avatar,
  AvatarCol,
  Label,
  LabelCol,
  LabelRow,
  Menu,
  PositionLabel,
  UserNav
} from './UserDropdown.style';
import { DropdownItem, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import PropTypes from 'prop-types';
import React from 'react';
import avatarPlaceholder from 'img/avatar-placeholder.png';

/**
 * A list of field rows with a header.
 *
 * @param {Object} props All the properties passed to the React Component.
 * @returns {Element} Stateless functional React component.
 */
const UserDropdown = (
  {
    isLoggedIn = false,
    pathname = '',
    replace = () => {},
    langOptions = [],
    lang = 'en',
    userName,
    clientLabel,
    clientCode,
    logout
  },
  { t }
) =>
  isLoggedIn && (
    <UserNav className="onboarding-tour user-drop-down">
      <UncontrolledDropdown nav>
        <DropdownToggle nav>
          {/* TODO: CLICKING THIS TWICE CAUSES AN ERROR IN CHROME */}
          <LabelRow>
            <LabelCol>
              <Label>
                {t('Hi,')} {userName}
              </Label>
              <PositionLabel>{clientLabel}</PositionLabel>
            </LabelCol>
            <AvatarCol>
              <Avatar src={avatarPlaceholder} />
            </AvatarCol>
          </LabelRow>
        </DropdownToggle>
        <Menu>
          {langOptions.map(({ label, code }) => (
            <DropdownItem
              disabled={lang === code}
              key={code}
              onClick={() => {
                replace(`/${code}/${clientCode}/${pathname}`);
              }}
            >
              {label}
            </DropdownItem>
          ))}
          <DropdownItem divider />
          <DropdownItem onClick={logout}>{t('Logout')}</DropdownItem>
        </Menu>
      </UncontrolledDropdown>
    </UserNav>
  );

UserDropdown.contextTypes = {
  t: PropTypes.func.isRequired
};

export default UserDropdown;



// WEBPACK FOOTER //
// ./src/components/common/Navigation/UserDropdown/UserDropdownComponent.js